import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  graphicDesignIcon,
  printMerch,
  brandingIcon,
} from "../../../../assets/icons/serviceIcon/index";
import UiUxDesigninhWork from "./UiUxDesigninhWork";
import { useEffect } from "react";

const items = [
  {
    name: "User Research & Wireframing",
    text: "Before we sketch a single screen, we take time to understand your users - their habits, struggles, and what makes them click (literally and emotionally).",
  },
  {
    name: "UI Design & Prototyping",
    text: "We don’t chase trends. We focus on clean, purposeful interfaces that make navigation feel like second nature. Every color, shape, and scroll is there for a reason - to make life easier for your users.",
  },
  {
    name: "UX Audits & Redesigns",
    text: "Already have a product but something feels off? We run UX audits that go beyond numbers, we spot where users get stuck or frustrated and redesign those moments into smooth, satisfying ones.",
  },
];

const otherService = [
  {
    icon: brandingIcon,
    name: "Branding & Identity",
    des: "Helping brands feel real, relatable, and ready to stand out.",
    path: "/branding-and-label",
  },
  {
    icon: graphicDesignIcon,
    name: "Graphic Design",
    des: " Designs that don’t just look good, but make people stop and stare.",
    path: "/graphic-designing",
  },
  {
    icon: printMerch,
    name: "Print & Merchandise Design",
    des: "Bring your brand to life with designs people want to own.",
    path: "/print-and-merchandise",
  },
];

const UiUxDesigning = () => {

      useEffect(() => {
      // Set Page Title
      document.title = "UI UX Design Services | User-Centric Design by TechQilla";
  
      // --- Description ---
      let metaDescription = document.querySelector<HTMLMetaElement>(
        "meta[name='description']",
      );
      if (!metaDescription) {
        metaDescription = document.createElement("meta");
        metaDescription.name = "description";
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute(
        "content",
        "TechQilla offers UI/UX design services focused on usability, aesthetics, and conversions to create seamless digital experiences",
      );
  
      // --- Keywords ---
      let metaKeywords = document.querySelector<HTMLMetaElement>(
        "meta[name='keywords']",
      );
      if (!metaKeywords) {
        metaKeywords = document.createElement("meta");
        metaKeywords.name = "keywords";
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.setAttribute("content", "UI UX Design Services");
      // --- Canonical ---
      let linkTag = document.querySelector<HTMLLinkElement>(
        "link[rel='canonical']",
      );
      if (!linkTag) {
        linkTag = document.createElement("link");
        linkTag.rel = "canonical";
        document.head.appendChild(linkTag);
      }
      linkTag.setAttribute("href", "https://www.techqilla.com/ui-ux-designing");
      }, []);
  
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Designing"
        description="Good design doesn’t shout - it effortlessly guides the users. We design digital experiences that feel natural, effortless, and just... right. Because when your users feel at home, they stay longer, explore more, and come back without being asked."
        heading="UI / UX"
      />
      <NewCommonServiceForm title="UI/UX Designing" items={items} />
      <UiUxDesigninhWork/>
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default UiUxDesigning;
